<template>
  <div class="container">
    <breadcrumb title="修改密码"></breadcrumb>
    <el-form :model="passwordForm" :rules="formRules" ref="passwordForm" label-position="left" label-width="0px" @keyup.enter.native="handlepasswd" class="passwd-container">
      <h3 class="title">修改密码</h3>
      <el-form-item prop="password">
        <el-input type="password" v-model="passwordForm.password" auto-complete="off" placeholder="新密码"></el-input>
      </el-form-item>
      <el-form-item prop="passwordConfirm">
        <el-input type="password" v-model="passwordForm.passwordConfirm" auto-complete="off" placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="width:100%;" type="primary" plain @click.native.prevent="handlepasswd('passwordForm')" :loading="changing">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.passwordForm.passwordConfirm !== '') {
          this.$refs.passwordForm.validateField('passwordConfirm')
        }
        callback();
      }
    };
    var validatePassConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      changing: false,
      passwordForm: {
        password: '',
        passwordConfirm: ''
      },
      formRules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        passwordConfirm: [{ validator: validatePassConfirm, trigger: 'blur' }]
      }
    };
  },
  methods: {
    handlepasswd(formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.$Api.post('/change_password', { password: this.passwordForm.password })
            this.$message.success('修改成功,请重新登录')
            setTimeout(() => {
              self.$router.push({ name: 'login' })
            }, 400);
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        } else {
          return false;
        }
      });
    }
  }
}

</script>
<style lang="scss" scoped>
.passwd-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 80px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
}

</style>
